import PageHeader from "../components/PageHeader";

const Programs = () => {
  return (
    <>
      <PageHeader />

      {/* Program 1: Pre-primary Support Program */}
      <div className="container-fluid bg-light p-5">
        <div className="container about px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div className="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
              <div className="position-relative h-100">
                <img className="position-absolute img-fluid w-100 h-100" src="img/ppsp.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 about-text wow fadeIn" data-wow-delay="0.5s">
              <div className="p-lg-5 pe-lg-0">
                <h1 className="mb-1 text-primary">Pre-primary Support Program (PPSP)</h1>
                <h4 className="mt-4">Nurturing Young Minds, Transforming Futures</h4>
                <p>We believe that the foundation of a child's future is laid between the ages of 2 to 5. It's a critical period of rapid intellectual and emotional growth. Our Pre-primary Support Program is designed to provide high-quality Montessori education to children in this age group, studying in Anganwadis and Corporation School Kindergartens.</p>
                <h4 className="mt-4">Empowering Early Learning, Achieving Remarkable Outcomes</h4>
                <p>Our team of well-trained Montessori teachers works closely with these institutions to create a nurturing environment that fosters curiosity, creativity, and social skills. By investing in early childhood education, we're helping shape the next generation of thinkers, leaders, and change-makers.</p>
                <h4 className="mt-4">Measurable Impact</h4>
                <p>Our program has consistently demonstrated remarkable outcomes, including:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Improved cognitive skills:</strong> Gain in problem-solving, critical thinking, and numeracy skills.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Enhanced social-emotional learning:</strong> Develop self-awareness, self-regulation and empathy.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Better preparedness for school:</strong> Smooth transition to primary school with confidence.</p>
                <p>By supporting our Pre-primary Support Program, you're investing in the future of these young minds and helping create a brighter, more equitable society for all.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="container" />

      {/* Program 2: Basic Literacy Program */}
      <div className="container-fluid bg-light p-5">
        <div className="container about px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div className="col-lg-6 about-text wow fadeIn" data-wow-delay="0.5s">
              <div className="p-lg-5 pe-lg-0">
                <h1 className="mb-1 text-primary">Basic Literacy Program</h1>
                <h4 className="mt-4">Empowering Young Minds with Foundational Skills</h4>
                <p>Our Basic Literacy Program is designed to support students in grades 1-5 from Corporation and Government-aided schools. We bridge the gap in foundational learning by providing essential skills in:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Vernacular language:</strong> Reading, writing, and comprehension.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>English:</strong> Reading, writing, and comprehension.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Basic Math:</strong> Numeracy skills and problem-solving.</p>
                <h4 className="mt-4">Volunteer-Led Learning</h4>
                <p>Our program relies on the dedication of volunteers and part-time staff who work closely with students to:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Identify learning gaps and provide targeted support.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Foster a supportive and encouraging learning environment.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Monitor progress and celebrate successes.</p>
                
                <h4 className="mt-4">Small Teacher-Student Ratios</h4>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Boosts confidence in academic abilities, reduces dropout rates, and develops strong foundation for future learning.</p>
              </div>
            </div>
            <div className="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
              <div className="position-relative h-100">
                <img className="position-absolute img-fluid w-100 h-100" src="img/blp.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="container" />

      {/* Program 3: Life Skills Program */}
      <div className="container-fluid bg-light p-5">
        <div className="container about px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div className="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
              <div className="position-relative h-100">
                <img className="position-absolute img-fluid w-100 h-100" src="img/lsp.jpg" alt="" />
              </div>
            </div>
            <div className="col-lg-6 about-text wow fadeIn" data-wow-delay="0.5s">
              <div className="p-lg-5 pe-lg-0">
                <h1 className="mb-1 text-primary">Life Skills Program</h1>
                <h4 className="mt-4">Empowering Adolescents for a Brighter Future</h4>
                <p>Our Life Skills Program is designed for students in grades 6-10 from Corporation and Government-aided schools. This holistic program focuses on developing essential life skills, universal values, and social awareness.</p>
                <h4 className="mt-4">Building Foundations for Success</h4>
                <p>Through this program, students acquire:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Soft skills:</strong> Effective communication, teamwork, problem-solving, and leadership.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Universal Values:</strong> Empathy, respect, responsibility and integrity.</p>
                <h4 className="mt-4">Expanding Horizons through Partnerships</h4>
                <p>We collaborate with other service providers and NGOs to bring awareness on critical issues, including:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Environment Protection:</strong> Understanding the importance of conservation and sustainability.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Health & Hygiene:</strong> Developing healthy habits and practices including Yoga.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Community Living:</strong> Fostering social responsibility and community engagement.</p>
                <h4 className="mt-4">Transforming Young Lives</h4>
                <p>By participating in our Life Skills Program, students will:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Develop into confident, self-assured individuals who can express themselves effectively.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Cultivate empathy, compassion, and respect for others, becoming more responsible and engaged members of their communities.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i>Acquire essential life skills, enabling them to make informed decisions, set goals, and work towards achieving them.</p>
                
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="container" />

      {/* Program 4: Leadership Through Sports */}
      <div className="container-fluid bg-light p-5">
        <div className="container about px-lg-0">
          <div className="row g-0 mx-lg-0">
            <div className="col-lg-6 about-text wow fadeIn" data-wow-delay="0.5s">
              <div className="p-lg-5 pe-lg-0">
                <h1 className="mb-1 text-primary">Leadership Through Sports</h1>
                <h4 className="mt-4">Unlocking Potential, Building Champions</h4>
                <p>Our innovative Leadership Through Sports program is a pilot project in partnership with a school in R.A. Puram. We harness the power of sports to instill leadership skills, teamwork, and discipline in children.</p>
                <h4 className="mt-4">Unlocking Potential, Building Champions</h4>
                <p>Through our program, children receive:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Regular training:</strong> At least 2 sessions/week,
                 focusing on various sports and activities.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Expert coaching:</strong> Committed sports resources provide guidance and mentorship to help children develop their skills.</p>
                <h4 className="mt-4">Building Confidence, Achieving Success</h4>
                <p>Our program encourages children to participate in:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Inter-school and intra-school competitions:</strong> Developing teamwork, strategy, and sportsmanship.</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong>Leadership opportunities:</strong> Fostering confidence, communication, and problem-solving skills.</p>
                <h4 className="mt-4">Empowering Young Leaders</h4>
                <p>By participating in our Leadership Through Sports program, children will:</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong> Improve their physical fitness and sports skills</strong></p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong> Develop essential life skills, </strong>such as teamwork, communication, and problem-solving</p>
                <p><i className="fa fa-check-circle text-primary me-3"></i><strong> Build confidence and self-esteem, </strong>enabling them to take on new challenges and pursue their goals</p>
              </div>
            </div>
            <div className="col-lg-6 ps-lg-0 wow fadeIn" data-wow-delay="0.1s">
              <div className="position-relative h-100">
                <img className="position-absolute img-fluid w-100 h-100" src="img/lts.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Programs;
